import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridActionsCellItem,
  GridDeleteIcon,
  GridToolbar,
} from "@mui/x-data-grid";
import ConfirmationModal from "../confirmation-modal/ConfirmationModal";
import SuccessAlert from "../success-alert/SuccessAlert";
import ErrorAlert from "../error-alert/ErrorAlert";
import { API } from "../../assets/staticData";
import EditIcon from "@mui/icons-material/Edit";
import EditCats from "../editors/EditCats";

export default function CategoriesDataTable({ data, setRefresh, refresh, user }) {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [confirmed2, setConfirmed2] = useState(false);
  const [clickedEntryId, setClickedEntryId] = useState();
  const [selected, setSelected] = useState([]);
  const [deleteSelected, setDeleteSelected] = useState(false);
  const [item, setItem] = useState({});

  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);

  let userToken = localStorage.getItem("userToken");

  const headers = {
    Authorization: `Bearer ${userToken}`,
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    { field: "category", headerName: "Category Name", width: 240 },
    { field: "items", headerName: "Items", width: 150 },
    { field: "slug", headerName: "Slug", width: 150 },
    {
      field: "date",
      headerName: "Date",
      width: 180,
    },
    {
      field: "language",
      headerName: "Language",
      width: 170,
    },
    {
      field: "actions",
      type: "actions",
      headerName: user.perms[20].edit || user.perms[20].delete ? "Actions" : "",
      cellClassName: "actions",
      width: 130,
      getActions: ({ id }) => {
        return [
          <>
            {user.perms[20].edit && (
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Delete"
                onClick={() => setItem({ id })}
              />
            )}
          </>,
          <>
            {user.perms[20].delete && (
              <GridActionsCellItem
                icon={<GridDeleteIcon />}
                label="Delete"
                onClick={handleDeleteClick(id)}
              />
            )}
          </>,
        ];
      },
    },
  ];

  const handleDeleteClick = (id) => () => {
    setOpen(true);
    setClickedEntryId(id);
  };

  useEffect(() => {
    async function deleteEntry() {
      if (confirmed == true) {
        fetch(`${API}/categories/${clickedEntryId}`, {
          headers,
          method: "DELETE",
        }).then(async (res) => {
          if (res.ok) {
            setSuccess(true);
            setRows(rows.filter((row) => row.id !== clickedEntryId));
            setConfirmed(false);
          } else {
            setFail(true);
            setConfirmed(false);
          }
        });
      }
    }

    deleteEntry();
  }, [confirmed]);

  useEffect(() => {
    let docs = [];
    data?.forEach((item) => {
      const articlesCount = item.attributes.articles?.data?.length || 0;
      const analysesCount = item.attributes.analyses?.data?.length || 0;
      const videosCount = item.attributes.videos?.data?.length || 0;
      const totalItems = articlesCount + analysesCount + videosCount;

      docs.push({
        id: item.id,
        category: item.attributes.category,
        language: item.attributes.language,
        url: item.attributes.url,
        slug: item.attributes.slug,
        date: new Date(item.attributes.createdAt).toLocaleDateString("tr-TR"),
        items: totalItems,
      });
    });
    setRows(docs);
  }, [data]);


  const deleteSelectedItems = async () => {
    setOpen2(true);
  };

  useEffect(() => {
    async function deleteSelected() {
      if (confirmed2 == true) {
        setDeleteSelected(false);
        try {
          await Promise.all(
            selected.map(async (item) => {
              await fetch(`${API}/categories/${item}`, {
                headers,
                method: "DELETE",
              });
            })
          );

          const updatedRows = rows.filter((row) => !selected.includes(row.id));
          setRows(updatedRows);
          setSelected([]);
          setSuccess(true);
        } catch (error) {
          console.error("Error deleting items:", error);
        }
      }
    }

    deleteSelected();
  }, [confirmed2]);

  return (
    <div style={{ width: "100%" }}>
      <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
      <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
      <DataGrid
        sx={{ minHeight: 580 }}
        disableColumnSorting
        disableAutosize
        disableColumnFilter
        onRowSelectionModelChange={(v) => {
          setSelected(v);
          if (v.length > 0) {
            setDeleteSelected(true);
          } else {
            setDeleteSelected(false);
          }
        }}
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 30]}
        checkboxSelection
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
          },
        }}
      />
      {deleteSelected && (
        <div onClick={deleteSelectedItems} className="deleteBTN">
          Delete Selected Items
        </div>
      )}
      <ConfirmationModal
        message={"Are you sure you want to delete this item?"}
        open={open}
        setOpen={setOpen}
        setConfirmed={(v) => setConfirmed(v)}
      />
      <ConfirmationModal
        message={"Are you sure you want to delete the selected items?"}
        open={open2}
        setOpen={setOpen2}
        setConfirmed={(v) => setConfirmed2(v)}
      />

      <EditCats
        endpoint={"categories"}
        itemToEdit={item}
        setItemToEdit={setItem}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </div>
  );
}
